"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DsCloud_1 = __importDefault(require("../DsCloud"));
var getFileSuffix_1 = require("./getFileSuffix");
function getContentDisposition(file) {
    var index = file.name.lastIndexOf('.');
    var name = file.name.substr(0, index);
    // 名称长度截取前20
    var fName = name.slice(0, 20);
    var suffix = getFileSuffix_1.getFileSuffix(file.name);
    // 若filename中带有,，则会使下载失败
    var fileName = fName + suffix;
    fileName = fileName.replace(/,/g, '-');
    return "attachment;filename=" + encodeURI(fileName);
}
// 处理请求头
function handleHeaders(headers, file, isDownLoad) {
    if (isDownLoad) {
        headers['Content-Disposition'] = getContentDisposition(file);
    }
    return headers;
}
/**
 *  上传方法，初始化 DsCloud
 * @param file 文件
 * @param options 上传配置
 */
function uploadDustessCloud(file, options, SDK) {
    if (SDK === void 0) { SDK = null; }
    return __awaiter(this, void 0, void 0, function () {
        var _a, type, key, ossRegion, isDownLoad, headers, accessKeyId, accessKeySecret, stsToken, bucket, secure, startTime, expiredTime, expiration, region, currentHeaders, client_1, res, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    _a = options.config, type = _a.type, key = _a.key, ossRegion = _a.ossRegion, isDownLoad = _a.isDownLoad, headers = _a.headers, accessKeyId = _a.accessKeyId, accessKeySecret = _a.accessKeySecret, stsToken = _a.stsToken, bucket = _a.bucket, secure = _a.secure, startTime = _a.startTime, expiredTime = _a.expiredTime, expiration = _a.expiration, region = _a.region;
                    currentHeaders = handleHeaders(headers, file, isDownLoad);
                    client_1 = new DsCloud_1.default({
                        type: type,
                        region: region || ossRegion,
                        accessKeyId: accessKeyId,
                        accessKeySecret: accessKeySecret,
                        stsToken: stsToken,
                        bucket: bucket,
                        key: key,
                        secure: secure,
                        startTime: startTime,
                        expiredTime: expiredTime,
                        expiration: expiration,
                        headers: currentHeaders
                    }, SDK);
                    return [4 /*yield*/, client_1.multipartUpload(file, {
                            progress: function (percent) {
                                options.progress({
                                    type: 'progress',
                                    result: { progress: percent },
                                    file: file,
                                    client: client_1
                                });
                            }
                        })
                        // 执行成功回调
                    ];
                case 1:
                    res = _b.sent();
                    // 执行成功回调
                    options.success({
                        type: 'success',
                        result: res,
                        file: file
                    });
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _b.sent();
                    // 执行失败回调
                    options.fail({
                        type: 'fail',
                        result: error_1,
                        file: file
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.uploadDustessCloud = uploadDustessCloud;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXBsb2FkRHVzdGVzc0Nsb3VkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3V0aWxzL3VwbG9hZER1c3Rlc3NDbG91ZC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLHVEQUFnQztBQUVoQyxpREFBK0M7QUFTL0MsU0FBUyxxQkFBcUIsQ0FBQyxJQUFVO0lBQ3ZDLElBQU0sS0FBSyxHQUFHLElBQUksQ0FBQyxJQUFJLENBQUMsV0FBVyxDQUFDLEdBQUcsQ0FBQyxDQUFBO0lBQ3hDLElBQU0sSUFBSSxHQUFHLElBQUksQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLENBQUMsRUFBRSxLQUFLLENBQUMsQ0FBQTtJQUN2QyxZQUFZO0lBQ1osSUFBTSxLQUFLLEdBQUcsSUFBSSxDQUFDLEtBQUssQ0FBQyxDQUFDLEVBQUUsRUFBRSxDQUFDLENBQUE7SUFDL0IsSUFBTSxNQUFNLEdBQUcsNkJBQWEsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUE7SUFDdkMsd0JBQXdCO0lBQ3hCLElBQUksUUFBUSxHQUFHLEtBQUssR0FBRyxNQUFNLENBQUE7SUFDN0IsUUFBUSxHQUFHLFFBQVEsQ0FBQyxPQUFPLENBQUMsSUFBSSxFQUFFLEdBQUcsQ0FBQyxDQUFBO0lBQ3RDLE9BQU8seUJBQXVCLFNBQVMsQ0FBQyxRQUFRLENBQUcsQ0FBQTtBQUNyRCxDQUFDO0FBRUQsUUFBUTtBQUNSLFNBQVMsYUFBYSxDQUFDLE9BQVksRUFBRSxJQUFVLEVBQUUsVUFBbUI7SUFDbEUsSUFBSSxVQUFVLEVBQUU7UUFDZCxPQUFPLENBQUMscUJBQXFCLENBQUMsR0FBRyxxQkFBcUIsQ0FBQyxJQUFJLENBQUMsQ0FBQTtLQUM3RDtJQUNELE9BQU8sT0FBTyxDQUFBO0FBQ2hCLENBQUM7QUFFRDs7OztHQUlHO0FBQ0gsU0FBc0Isa0JBQWtCLENBQUMsSUFBVSxFQUFFLE9BQTBCLEVBQUUsR0FBYztJQUFkLG9CQUFBLEVBQUEsVUFBYzs7Ozs7OztvQkFJekYsS0FnQkUsT0FBTyxPQURSLEVBZEMsSUFBSSxVQUFBLEVBQ0osR0FBRyxTQUFBLEVBQ0gsU0FBUyxlQUFBLEVBQ1QsVUFBVSxnQkFBQSxFQUNWLE9BQU8sYUFBQSxFQUNQLFdBQVcsaUJBQUEsRUFDWCxlQUFlLHFCQUFBLEVBQ2YsUUFBUSxjQUFBLEVBQ1IsTUFBTSxZQUFBLEVBQ04sTUFBTSxZQUFBLEVBQ04sU0FBUyxlQUFBLEVBQ1QsV0FBVyxpQkFBQSxFQUNYLFVBQVUsZ0JBQUEsRUFDVixNQUFNLFlBQUEsQ0FFQztvQkFHTCxjQUFjLEdBQUcsYUFBYSxDQUFDLE9BQU8sRUFBRSxJQUFJLEVBQUUsVUFBVSxDQUFDLENBQUE7b0JBR3pELFdBQVMsSUFBSSxpQkFBTyxDQUFDO3dCQUN6QixJQUFJLE1BQUE7d0JBQ0osTUFBTSxFQUFFLE1BQU0sSUFBSSxTQUFTO3dCQUMzQixXQUFXLGFBQUE7d0JBQ1gsZUFBZSxpQkFBQTt3QkFDZixRQUFRLFVBQUE7d0JBQ1IsTUFBTSxRQUFBO3dCQUNOLEdBQUcsS0FBQTt3QkFDSCxNQUFNLFFBQUE7d0JBQ04sU0FBUyxXQUFBO3dCQUNULFdBQVcsYUFBQTt3QkFDWCxVQUFVLFlBQUE7d0JBQ1YsT0FBTyxFQUFFLGNBQWM7cUJBQ3hCLEVBQUUsR0FBRyxDQUFDLENBQUE7b0JBR0sscUJBQU0sUUFBTSxDQUFDLGVBQWUsQ0FBQyxJQUFJLEVBQUU7NEJBQzdDLFFBQVEsRUFBRSxVQUFDLE9BQWU7Z0NBQ3hCLE9BQU8sQ0FBQyxRQUFRLENBQUM7b0NBQ2YsSUFBSSxFQUFFLFVBQVU7b0NBQ2hCLE1BQU0sRUFBRSxFQUFFLFFBQVEsRUFBRSxPQUFPLEVBQUU7b0NBQzdCLElBQUksRUFBRSxJQUFJO29DQUNWLE1BQU0sRUFBRSxRQUFNO2lDQUNmLENBQUMsQ0FBQTs0QkFDSixDQUFDO3lCQUNGLENBQUM7d0JBRUYsU0FBUztzQkFGUDs7b0JBVEksR0FBRyxHQUFHLFNBU1Y7b0JBRUYsU0FBUztvQkFDVCxPQUFPLENBQUMsT0FBTyxDQUFDO3dCQUNkLElBQUksRUFBRSxTQUFTO3dCQUNmLE1BQU0sRUFBRSxHQUFHO3dCQUNYLElBQUksRUFBRSxJQUFJO3FCQUNYLENBQUMsQ0FBQTs7OztvQkFFRixTQUFTO29CQUNULE9BQU8sQ0FBQyxJQUFJLENBQUM7d0JBQ1gsSUFBSSxFQUFFLE1BQU07d0JBQ1osTUFBTSxFQUFFLE9BQUs7d0JBQ2IsSUFBSSxFQUFFLElBQUk7cUJBQ1gsQ0FBQyxDQUFBOzs7Ozs7Q0FFTDtBQW5FRCxnREFtRUMifQ==